import styled from "styled-components";
import { Button, Form } from 'antd';

export const StyledFormWrap = styled.div`
  padding-top: 1rem;

  form {
    padding: 1rem;
    border-radius: 1rem;
    background: #EFEEF1;
  }
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0.5rem;
  & .ant-form-item-label {
    padding-bottom: 0.25rem;
  }
  .ant-form-item-control-input {
    min-height: auto;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 0.5rem;
  background: #67DD61;
  height: 2.75rem !important;

  &:hover {
    border: 1px solid #67DD61 !important;
    color:rgb(53, 147, 48) !important;
  }
`;
